angular.module('iw.frontyard.signup')
    .directive('iwBlurChild', function () {
        return {
            restrict: 'A',
            require: '^iwBlurContainer',
            link: function (scope, element, attributes, iwBlurContainer) {

                iwBlurContainer.register(element);

            }
        };
    });